import { render, staticRenderFns } from "./ShopByPattern.vue?vue&type=template&id=5e77ee2a&scoped=true&lang=pug&"
import script from "./ShopByPattern.vue?vue&type=script&lang=js&"
export * from "./ShopByPattern.vue?vue&type=script&lang=js&"
import style0 from "./ShopByPattern.vue?vue&type=style&index=0&id=5e77ee2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77ee2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e77ee2a')) {
      api.createRecord('5e77ee2a', component.options)
    } else {
      api.reload('5e77ee2a', component.options)
    }
    module.hot.accept("./ShopByPattern.vue?vue&type=template&id=5e77ee2a&scoped=true&lang=pug&", function () {
      api.rerender('5e77ee2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/ShopByPattern.vue"
export default component.exports